import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { LoadingService } from '@core/services/loading.service';
import { ColumnMode, DatatableComponent, SelectionType } from '@swimlane/ngx-datatable';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HomeComponent implements OnInit {
  public arrCoupons: any[] = [];
  public lang: string = 'ar';
 
  constructor( 
    private apisService: ApisService,
    // private loadingService: Loadingscr,
    private router: Router,
        private toastr : ToastrService, 
        private loading: LoadingService,
  ) {} 

  goToStoriesAll() {
    this.router.navigate(['/stories']);
  }

  goToStoriesPending() {
    // Navigate to stories list; the list is client-side filtered, so we pass a search hint.
    this.router.navigate(['/stories'], { queryParams: { q: 'pending' } });
  }


  public currentPage = 1; 
  public itemsPerPage = 10;
  public totalItems = 0;
  public ColumnMode = ColumnMode;
  public SelectionType = SelectionType;

 
  public levels: any[] = [];
  public tempData = [];
  public statistics:any

  @ViewChild(DatatableComponent) table: DatatableComponent;

 
 ngOnInit(): void {
    this.lang = localStorage.getItem('currentLang') || 'ar';
    this.getHomeStatistics()

  }
 
getHomeStatistics(){
  this.loading.show()
  this.apisService.getHomeStatistics().subscribe({
    next: (res) => {
      this.statistics = res.data
      this.loading.hide()
    },
    error: (err) => {
      console.log('error in fetching', err)
      this.loading.hide()
    }
  })
} 

  filterUpdate(event) {
    const val = event.target.value.toLowerCase();
    this.arrCoupons = this.tempData.filter((d) =>
      d.code.toLowerCase().includes(val)
    );
    this.table.offset = 0;
  }


  
}
